import service from "@/utils/request";

// 点名记录列表导出( 按班级 )
interface roolCallExportData {
  class_id?: number;
  teacher_id?: number;
  course_id?: number;
  staff_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
}
export const roolCallExport = (params: roolCallExportData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/export",
    method: "get",
    params,
  });
};
// 订单导出
interface orderExportData {
  page?: number;
  page_size?: number;
  student_key_word?: string;
  order_no?: string;
  belong?: number;
  create_time_start?: string;
  create_time_end?: string;
  payment_status?: number;
  status?: number;
}
export const orderExport = (data: orderExportData) => {
  return service({
    url: "/api/v1/order/list/export",
    method: "post",
    data,
  });
};
// 订单列表（明细）导出
export interface exportOrderItemListData {
  order_no?: string;
  order_type?: number;
  order_type_arr?: number[];
  student_key_word?: string;
  create_staff_id?: number;
  belong?: number;
  course_id?: number;
  create_time_start?: string;
  create_time_end?: string;
  handle_time_start?: string;
  handle_time_end?: string;
  business_type?: number;
  payment_status?: number;
  subject_id?: number;
  refund_time_start?: string;
  refund_time_end?: string;
  approval_status_arr?: number[];
  item_type?: number;
  payment_type?: number;
}
export const exportOrderItemListApi = (data: exportOrderItemListData) => {
  return service({
    url: "/api/v1/order/item_list/export",
    method: "post",
    data,
  });
};
// 课表导出
export interface exportLessonScheduleData {
  start_date: string;
  end_date: string;
  course_ids?: number[];
  class_ids?: number[];
  teacher_ids?: number[];
  student_ids?: number[];
  lesson_type?: number;
  roll_call_status?: number;
  course_type?: number;
  class_student_full?: number;
  student_type?: number;
  roll_call_student_status?: number;
  simplify?: boolean;
  classroom_ids?: number[];
}
export const exportLessonScheduleApi = (data: exportLessonScheduleData) => {
  return service({
    url: "/api/v1/timetable/export",
    method: "post",
    data,
  });
};
